export const isLocalEnv =
  process.env.PHONOS_GATEWAY_URL?.match(/127.0.0.1/) ||
  process.env.PHONOS_GATEWAY_URL?.match(/:31337/) ||
  process.env.PHONOS_GATEWAY_URL?.match(/local/);

export const isEphemeralOrLocalEnv =
  isLocalEnv || process.env.PHONOS_GATEWAY_URL?.match(/ephemeral/);

export const isStageOrEphemeralOrLocalEnv =
  isEphemeralOrLocalEnv || process.env.PHONOS_GATEWAY_URL?.match(/stage/);

export const isProductionEnv = !isStageOrEphemeralOrLocalEnv;

const FADE_CURVE_LENGTH = 20;
export const FADE_OUT_CURVE = Array<number>();
for (let i = 1; i <= FADE_CURVE_LENGTH; i++) {
  FADE_OUT_CURVE.push(Math.cos(i * (1 / FADE_CURVE_LENGTH) * (Math.PI / 2.0)));
}

export const FADE_IN_CURVE = Array<number>();
for (let i = 1; i <= FADE_CURVE_LENGTH; i++) {
  FADE_IN_CURVE.push(
    Math.abs(
      Math.cos(Math.PI / 2.0 + i * (1 / FADE_CURVE_LENGTH) * (Math.PI / 2.0))
    )
  );
}

export const MICRO_FADE_DURATION_MS = 25;
export const LONG_FADE_DURATION_MS = 5000;
export const FADE_SHIFT_OFFSET_MS = 2000;
